import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { execute, gql } from '~/services-v2/financial-bff/financial-bff-gql'
import hotjar from '~/services-v2/hotjar/hotjar'

export default function useInstallation(projectId: Ref<string | undefined | null>) {
  const queryKey = queryKeys.INSTALLATION.DETAILS(projectId)

  const queryFn = async () => {
    if (!projectId.value) {
      throw new Error('Project ID is required')
    }

    const query = gql(`
      query Installation($projectId: String!) {
        installation(projectId: $projectId) {
          comment
          concluded_at
          grade
          has_ampera
          has_ampera_activated
          has_minimal_projects
          id
          new_journey
          plant_url
          project_id
          project_name
          stage
          stage_customer_phone
          stage_updated_at
          plant_id
          stage_error
          sections {
            documents {
              filename
              filetype
              id
              type
              url
            }
            id
            status {
              description
              id
              slug
            }
            type
          }
          status {
            description
            id
            slug
          }
          installed_inverters {
            status
            inverters {
              id
              model
              brand
              power_kw
              serial_number
              datalogger_serial_number
              status
              entry_mode
              created_at
              updated_at
            }
          }
        }
      }
    `)

    const res = await execute(query, {
      projectId: projectId.value,
    })

    if (res.installation?.status?.slug === 'success') {
      hotjar.track('installation_finished', {
        project_id: projectId.value,
      })
    }

    if (res.installation?.status?.slug === 'error') {
      hotjar.track('installation_error', {
        project_id: projectId.value,
      })
    }

    if (res.installation?.status?.slug === 'waiting') {
      hotjar.track('installation_waiting', {
        project_id: projectId.value,
      })
    }

    return res.installation!
  }

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!projectId.value,
  })
}

export type UseInstallation = ReturnType<typeof useInstallation>
export type UseInstallationData = UseInstallation['data']['value']
